import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@material-ui/core';

const getSrc = (imgKey, avatar) => {
  if (avatar && avatar.indexOf('http') >= 0) {
    // to avoid browser cache append random param
    return `${avatar}?date=${new Date(!imgKey
      ? 0
      : imgKey).toISOString()}`;
  }
  return avatar;
};

const TenantAvatar = (props) => (
  <Avatar
    style={{ color: props.tenant.iconColor }}
    src={getSrc((!props.tenant.updatedDate
      ? props.tenant.creationDate
      : props.tenant.updatedDate), props.tenant.avatar)}
  >
    {
      props.tenant
      && props.tenant.displayName
      && !props.tenant.avatar
      && props.tenant.displayName.charAt(0)
    }
  </Avatar>
);

TenantAvatar.propTypes = { tenant: PropTypes.object.isRequired };

export default TenantAvatar;
